<script>
import Layout from "../../layouts/main.vue";
import Heading from "../../layouts/heading.vue";
import FormBuilder from "../../layouts/FormBuilder.vue";
import { schema } from "./data";
import api from "../../../api";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';

export default {
  props: {
    category: {},
  },
  components: { 
    FormBuilder, 
    Layout,
     Heading
  },
  data() {
    return {
      page: schema,
      currentTopicActiveStatus: false,
      location_list: [],
      topics: [],
      topbar: {},
      selectedTab: '',
      selectedItem: {},
    };
  },
  methods: {
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;

      return [year, month, day].join('-');
    },
    create() {
        var val = this.page.tabs.filter(tab => tab.name == this.selectedTab)[0].formData;

        var data = {
          uuid: uuidv4(),
          url: val.name.replaceAll(' ', '-'),
          active: true,
          title: val.name,
          picture: '',
          excerpt: 'Text here',
          description: '',
          deleted: false,          
          creationDate: new Date().toISOString(),
          lastModifiedDate: new Date().toISOString(),
          categoryId: this.category.id,
          cmsId: this.currentCms.id,
          pcnId: this.currentPracticeData.pcnId,
          additionalProp1: {
            date: this.formatDate(new Date()),
            featured: false,
            image_url: '',
            video_url: '',
            media_type: 'Video',
            dynamoId: this.currentPractice.additionalProp1.dynamo,            
          }
        };

        api.post('/api/categories/'+this.category.id+'/pages', data)
        .then((response) => {
          Swal.fire("Topic Added!", "Topic Added Successfully!", "success");
          this.page.tabs[0].side_panel.select_a_page.options.unshift(response.data);  
          this.topbar.deleteBtn = true;
          this.topbar.activeBtn = true;        
        }, (error) => {
          console.log(error);
        });
    },
    deleted() {
      var self = this;
      Swal.fire({
        title: `Are you sure you want to delete ${self.selectedItem.title}?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          api.delete('/api/pages/'+this.selectedItem.id)
          .then(() => {
            Swal.fire("Topic Deleted!", "Topic Deleted Successfully!", "warning");
            this.page.tabs[0].side_panel.select_a_page.options
            .splice(
              this.page.tabs[0].side_panel.select_a_page.options.findIndex(function(i){
              return i.id === self.selectedItem.id;
            }), 1);
            if(this.page.tabs[0].side_panel.select_a_page.options.length == 0) {
              this.topbar.deleteBtn = false;
              this.topbar.activeBtn = false;
              this.$store.commit('updateOldFormData', new Object())
              this.$store.commit('updateCurrentFormData', new Object())
            }
          }, (error) => {
            console.log(error);
          });
        }
      });
    },
    submit(val) {
      if(this.selectedTab == 'News'){
        var data = {
          title: val.title,
          description: val.description,
          url: val.path,
          active: this.currentTopicActiveStatus,
          additionalProp1: {
            featured: val.featured,
            date: val.date,
            media_type: val.upload_options,
            image_url: val.image_url,
            video_url: val.video_url,
            dynamoId: this.currentPractice.additionalProp1.dynamo,
          },
        };

        api.patch('/api/pages/'+val.id, data)
        .then(() => {
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].title = val.title;         
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].description = val.description;         
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].active = this.currentTopicActiveStatus;         
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].additionalProp1.featured = val.featured;    
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].additionalProp1.date = val.date;    
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].additionalProp1.media_type = val.upload_options;    
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].additionalProp1.image_url = val.image_url;    
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].additionalProp1.video_url = val.video_url;    
            Swal.fire("Topic Updated!", "Topic Updated Successfully!", "success");
        }, (error) => {
          console.log(error);
        });
      }
    },
    activateToggle() {
      this.currentTopicActiveStatus = !this.currentTopicActiveStatus;
      var data = {
        active: this.currentTopicActiveStatus
      };
      api.patch('/api/pages/'+this.selectedItem.id, data)
      .then(() => {       
          let item = this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == this.selectedItem.id)[0];
          item.active = this.currentTopicActiveStatus;
          this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == this.selectedItem.id)[0] = item;
          this.$store.commit('updateOldFormData', item)
          this.$store.commit('updateCurrentFormData', item) 
          Swal.fire("Topic Status Updated!", "Topic Status Updated Successfully!", "success");
      }, (error) => {
        console.log(error);
      });
    },
    selectedItemFn(val) {
      this.selectedItem = val;
      this.currentTopicActiveStatus = val.active;
    },
    selectedTabFn(val) {
      this.selectedTab = val;
      this.topbar = this.page.tabs.filter(tab => tab.name == val)[0];
    },
    getPages() {
      api.get('/api/categories/'+this.category.id+'/pages')
      .then(response => {
        this.topics = response.data.sort((a, b) => a.additionalProp1.position - b.additionalProp1.position)
        this.page.tabs[0].side_panel.select_a_page.options = this.topics;
        this.topbar = this.page.tabs[0];   
        if(response.data.length == 0) {
          this.topbar.deleteBtn = false;
          this.topbar.activeBtn = false;
        }      
      })
      .catch(e => {
        console.log(e)
      })  
    },
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.getPages();
  }
};
</script>

<template>
  <Layout>
    <Heading :page="topbar" 
      :activeStatus="currentTopicActiveStatus" 
      @activateToggle="activateToggle"
      @created="create" 
      @deleted="deleted" 
      @form-submitted="submit"
    >
    </Heading>
    <FormBuilder :schema="page" :category="category" @selected-tab="selectedTabFn" @submit="submit" @selected-item="selectedItemFn">
    </FormBuilder>
  </Layout>
</template>